import React from 'react'

function CreateTicket() {
    return (

        <div className='container'>
            <div className='row p-5 mt-5 mb-5'>
                <h1 className='fs-2'>
                    To create a ticket, select a relevant topic
                </h1>
                <div className='col-4 p-5 mt-5 mb-5'>
                    <h4 className='mb-5'>
                        <i class="fa-solid fa-circle-plus" style={{ fontSize: "18px" }}></i> Account Opening
                    </h4>
                    <a href="" className='lh-lg'> Resident individual</a> <br />
                    <a href="" className='lh-lg'> Minor</a> <br />
                    <a href="" className='lh-lg'> Non Resident Indian (NRI)</a> <br />
                    <a href="" className='lh-lg'> Company, Partnership, HUF and LLP</a> <br />
                    <a href="" className='lh-lg'> Glossary</a> <br />
                </div>
                <div className='col-4 p-5 mt-5 mb-5'>
                    <h4 className='mb-5'>
                        <i class="fa-regular fa-circle-user" style={{ fontSize: "18px" }}></i> Your StockEdge Account
                    </h4>
                    <a href="" className='lh-lg'> Your Profile</a> <br />
                    <a href="" className='lh-lg'> Account modification</a> <br />
                    <a href="" className='lh-lg'> Client Master Report (CMR) and Depository Participant (DP)</a> <br />
                    <a href="" className='lh-lg'> Nomination</a> <br />
                    <a href="" className='lh-lg'> Transfer and conversion of securities</a> <br />
                </div>
                <div className='col-4 p-5 mt-5 mb-5'>
                    <h4 className='mb-5'>
                        <i class="fa-regular fa-envelope" style={{ fontSize: "18px" }}></i> Kite
                    </h4>
                    <a href="" className='lh-lg'> IPO</a> <br />
                    <a href="" className='lh-lg'> Trading FAQs</a> <br />
                    <a href="" className='lh-lg'> Margin Trading Facility (MTF) and Margins</a> <br />
                    <a href="" className='lh-lg'> Charts and orders</a> <br />
                    <a href="" className='lh-lg'> Alerts and Nudhes</a> <br />
                    <a href="" className='lh-lg'> General</a> <br />
                </div>
                <div className='col-4 p-5 mt-5 mb-5'>
                    <h4 className='mb-5'>
                        <i class="fa-solid fa-indian-rupee-sign" style={{ fontSize: "18px" }}></i> Funds
                    </h4>
                    <a href="" className='lh-lg'> Add Monay</a> <br />
                    <a href="" className='lh-lg'> Withdraw money</a> <br />
                    <a href="" className='lh-lg'> Add bank account</a> <br />
                    <a href="" className='lh-lg'> eMandates</a> <br />
                </div>
                <div className='col-4 p-5 mt-5 mb-5'>
                    <h4 className='mb-5'>
                        <i class="fa-solid fa-circle-notch" style={{ fontSize: "18px" }}></i> Console
                    </h4>
                    <a href="" className='lh-lg'> Portfolio</a> <br />
                    <a href="" className='lh-lg'> Corporate</a> <br />
                    <a href="" className='lh-lg'> Funds statement</a> <br />
                    <a href="" className='lh-lg'> Report</a> <br />
                    <a href="" className='lh-lg'> Profile</a> <br />
                    <a href="" className='lh-lg'> Segments</a> <br />
                </div>
                <div className='col-4 p-5 mt-5 mb-5'>
                    <h4 className='mb-5'>
                        <i class="fa-solid fa-coins" style={{ fontSize: "18px" }}></i> Coin
                    </h4>
                    <a href="" className='lh-lg'> Mutual funds</a> <br />
                    <a href="" className='lh-lg'> National Pension Scheme (NPS)</a> <br />
                    <a href="" className='lh-lg'> Fixed Deposit (FD)</a> <br />
                    <a href="" className='lh-lg'> Feature on Coin </a> <br />
                    <a href="" className='lh-lg'> Pyments and Orders</a> <br />
                    <a href="" className='lh-lg'> General</a> <br />
                </div>
            </div>
        </div>
    );
}

export default CreateTicket;